import React from 'react';
import { useIntl } from 'react-intl';

import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

import messages from './messages';
import { ShowOnAvailabilitiesListEnum } from './types';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 'fit-content',
    },
  },
};

interface TimeZoneSelectorProps {
  timeZonesOptions: Array<{
    name: string;
    value: ShowOnAvailabilitiesListEnum;
  }>;
  currentTimeZoneSettng: string;
  onTimeZoneChange: (timezoneOption: ShowOnAvailabilitiesListEnum) => void;
}

const TimeZoneSelector: React.FC<TimeZoneSelectorProps> = ({
  timeZonesOptions,
  currentTimeZoneSettng,
  onTimeZoneChange,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      <FormControl variant="standard">
        <InputLabel id="timezone-selector-label">{formatMessage(messages.timeZone)}</InputLabel>
        <Select
          id="timezone-selector"
          value={currentTimeZoneSettng}
          onChange={({ target: { value } }) => onTimeZoneChange(value as ShowOnAvailabilitiesListEnum)}
          MenuProps={MenuProps}
        >
          {timeZonesOptions.map(({ value, name }) => (
            <MenuItem id={`timezone-selector-item-${value}`} key={value} value={value}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default TimeZoneSelector;
